import React, { memo, useContext, useEffect, useReducer } from 'react';
import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import './css/HomePage1Articles2.css';
import { NavLink } from 'react-router-dom';
import { context } from '../../../../../../globalState/GlobalState';
import { fetchLimitedArticlesAPI } from '../../../../../apiCalls/ArticleAPICalls';
import Spinner1 from '../../../../../uiElements/spinners/spinner1/Spinner1';
import ArticleThumbnail3 from '../../../../../uiElements/articleThumbnails/articleThumbnail3/ArticleThumbnail3';

const initialState = {
    articles: [],
    loadingSpinner: true,
};

function reducer(state, action) {
    switch (action.type) {
        case 'fetchArticles':
            return { ...state, articles: action.articles };
        case 'setLoadingSpinner':
            return { ...state, loadingSpinner: action.loadingSpinner };
        default:
            return initialState;
    }
}

const HomePage1Articles2 = (props) => {
    const { whiteTitle } = props;
    const [state, setState] = useReducer(reducer, initialState);
    const { globalState } = useContext(context);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        async function fetchArticles() {
            setState({ type: 'setLoadingSpinner', loadingSpinner: true });
            await fetchLimitedArticlesAPI(globalState.accountId, 8, setState, enqueueSnackbar);
            setState({ type: 'setLoadingSpinner', loadingSpinner: false });
        }
        fetchArticles();
    }, []);

    return (
        <div className="homepage1-articles2-container full-width">
            <NavLink to="/articles" className={whiteTitle ? 'alegreya-font-family font-weight-500 m-t-0 m-l-0 m-r-0 m-b-10px text-center-align font-size-m text-uppercase full-width text-white text-no-underline' : 'alegreya-font-family font-weight-500 m-t-0 m-l-0 m-r-0 m-b-10px text-center-align font-size-m text-uppercase full-width text-black text-no-underline'}>Articles</NavLink>
            <div className="homepage1-articles2 homepage1-articles2-desktop">
                {state.loadingSpinner ? (<Spinner1 color={globalState.websiteStyles.colors.primaryColor} marginTop={100} />) : (
                    <>
                        {state.articles.map((article) => {
                            return (
                                <div key={article.id} className="homepage1-article2-container m-b-10px">
                                    <ArticleThumbnail3 article={article} />
                                </div>
                            );
                        })}
                    </>
                )}
            </div>
            <div className="homepage1-articles2 homepage1-articles2-mobile">
                {state.loadingSpinner ? (<Spinner1 color={globalState.websiteStyles.colors.primaryColor} marginTop={100} />) : (
                    <>
                        {state.articles.slice(0, 6).map((article) => {
                            return (
                                <div key={article.id} className="homepage1-article2-container m-b-10px">
                                    <ArticleThumbnail3 article={article} />
                                </div>
                            );
                        })}
                    </>
                )}
            </div>
        </div>
    );
};

HomePage1Articles2.propTypes = {
    whiteTitle: PropTypes.bool,
};

HomePage1Articles2.defaultProps = {
    whiteTitle: false,
};

export default memo(HomePage1Articles2);
